import { View } from "./View";

export { View };
export default View;
